import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class PaymentForBankStatement {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsNumber()
  amount!: number;
  @Expose()
  @IsNumber()
  amountInCurrency!: number;
  @Expose()
  @IsString()
  currency!: string;
  @Expose()
  @IsString()
  formOfPayment!: string;
  @Expose()
  @IsString()
  transactionDate!: string;
  @Expose()
  @IsString()
  createDate!: string;
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  wholeTransfer!: null | number;
  @Expose()
  @IsNumber()
  gross!: number;
  @Expose()
  @IsBoolean()
  matchIsEnable!: boolean;
  @Expose()
  @IsBoolean()
  deleteMatchIsEnable!: boolean;
}
